import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { DynamicFormField, FormComponent } from '@teamfoster/dynamic-forms';
import { Filter } from '../../../shop';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-product-filters',
  templateUrl: './product-filters.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormComponent, FromDictionaryPipe],
})
export class ProductFiltersComponent implements OnInit {
  private cd = inject(ChangeDetectorRef);

  @Input() filters?: Filter[];
  @Input() activeFilters?: any;
  @Input() initWithValue?: any;
  @ViewChild(FormComponent, { static: false }) form?: FormComponent;
  @Output() filtered = new EventEmitter<{ [key: string]: string }>();

  formFields: DynamicFormField[] = [];

  ngOnInit(): void {
    this.formFields =
      this.filters?.map((filter, i) => {
        return {
          label: filter.label,
          name: filter.id.replace(/\./g, '-'),
          validators: [],
          fieldType: 'radio-list',
          order: i,
          value: this.initWithValue[filter.id.replace(/\./g, '-')],
          selectOptions: filter.values.map(value => {
            return {
              title: value.label,
              id: value.id,
            };
          }),
          groupOpen: !!this.initWithValue[filter.id.replace(/\./g, '-')],
        };
      }) || [];
  }

  reset() {
    this.form?.form.reset();
    this.cd.detectChanges();
  }

  get hasFiltersActive(): boolean {
    return (this.form?.form.value && Object.values(this.form?.form.value).some(value => value)) || false;
  }

  submit() {
    this.filtered.emit(this.form?.form.value);
  }
}
